import React from "react";
import axios from 'axios';
import { LazyLoadImage } from "react-lazy-load-image-component";
import CommonProjectViewSection from "./CommonProjectViewSection";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";

class OpportunitiesJobSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opportunitiesJobDataList: [],
            responseMessage: ''
        }
    }
    componentDidMount(){
        this.getAllOpportunitiesJobDataList();
    }

    getAllOpportunitiesJobDataList = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/unauth/landingpageproject`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
            .then((response) => {
                if (response && response.data && response.data.message === "Success!") {
                    this.setState({
                        opportunitiesJobDataList: response?.data?.body,
                        responseMessage: response.data?.message
                        
                    })
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    getSkeletonData = () => {
        
        return(
            <div className='lndSolOppertunJobsList'>
                            <div className='row'>
                                {Array(3).fill().map((opportunity,index) => {
                                return (                                    
                                    <div className='col-md-4 oppertunCol'>
                                        <SkeletonTheme>
                                            <div className="lndprojeventlist">
                                                <div className="lndprojeventlistinn">
                                                    <figure className="lndeventimg">
                                                        <Skeleton height={58} width={'100%'}/>
                                                    </figure>
                                                    <div className="lndprojeventdesc">
                                                        <div className="d-flex">
                                                            <div className="lnddate">
                                                                <Skeleton height={28} width={`100%`}/>
                                                                <span style={{marginTop: '3px'}}><Skeleton height={12} width={`100%`}/></span>
                                                                <span style={{marginTop: '3px'}}><Skeleton height={12} width={`100%`}/></span>
                                                            </div>
                                                            <div className="lndprojeventdesctxt" style={{width: '100%'}}>
                                                                <h4><Skeleton height={36} width={`100%`}/></h4>
                                                                <Skeleton height={15} width={`100%`}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SkeletonTheme>
                                    </div>
                                )
                                })}
                            </div>
            </div>
        )

    }

    render() {
        const{opportunitiesJobDataList} = this.state;

        return (
            <div className='lndSolOppertunJobs'>
                <h4>Opportunities to &nbsp;<div className="carouselWrap">
                        <OwlCarousel
                            items='1'
                            rewind='true'
                            autoplay='true'
                            loop="true"
                            autoplayTimeout='1800'
                            lazyContent="true"
                        >

                            <span>Assignments</span>
                            <span>Events</span>
                            <span>Jobs</span>
                            <span>Trainings</span>
                            <span>Expeditions</span>
                            <span>Storybook</span>
                            <span>Fund Raise</span>

                        </OwlCarousel>
                    </div></h4>
                    {this.state.responseMessage === 'Success!' ?  
                        <div className='lndSolOppertunJobsList'>
                            <div className='row'>
                                {opportunitiesJobDataList && opportunitiesJobDataList.length > 0 && opportunitiesJobDataList.slice(0,3).map((opportunity,index) => {
                                return <CommonProjectViewSection item={opportunity} key={index} sectionType={"OPPORTUNITES"} />
                                })}
                            </div>
                        </div>
                        : (
                            this.getSkeletonData()
                        )
                }
               
            </div>
        );
    }
}

export default OpportunitiesJobSection;